<script lang="ts" setup>
  import { marked } from 'marked'
  import type { RipType } from '@/components/release-in-progress/types'
  import { useReleaseInProgressDataLayer } from '@/composables/data-layers/useReleaseInProgressDataLayer'
  import { useReleaseInProgressSentry } from '@/composables/useReleaseInProgressSentry'

  const props = withDefaults(
    defineProps<{
      page: RipType
      texts?: {
        title: string
        description: string
      }
    }>(),
    {
      texts: undefined
    }
  )

  const { t } = useI18n()

  useReleaseInProgressDataLayer(() => props.page)
  useReleaseInProgressSentry(() => props.page)

  const texts = computed(() => {
    return {
      title: !props.texts?.title ? t(`rip.${props.page}.title`) : props.texts.title,
      description: !props.texts?.description ? t(`rip.${props.page}.description`) : props.texts.description
    }
  })

  const description = computed(() => marked(texts.value.description))
</script>
<template>
  <div
    class="mt-4 flex items-center justify-center rounded-2md bg-gradient-to-b from-[#FFBD9C] to-[#C3EEFF] px-5 md:mx-5 lg:mx-10 lg:max-w-full"
  >
    <div
      class="flex flex-col items-center justify-end md:w-282 md:flex-row md:justify-between xl:w-354 xl:justify-start xl:gap-48"
    >
      <div
        class="mt-12 flex max-w-80 flex-col items-center justify-center gap-0 text-center md:m-0 md:max-w-138 md:justify-between md:gap-4"
      >
        <div class="flex flex-col items-center justify-center gap-0 md:w-full md:flex-row md:justify-start md:gap-4">
          <div
            class="mt-4 text-xl font-medium leading-9 sm:max-w-112 md:m-0 md:text-2xl md:leading-10"
            v-html="texts.title"
          />
        </div>

        <div
          class="mt-1 text-body-1 md:m-0 md:text-left md:text-body-large [&_a]:text-body-1 md:[&_a]:text-body-large"
          v-html="description"
        />
      </div>

      <NuxtImg
        provider="ipx"
        src="/rip.png"
        :alt="`${t(`rip.imgAlt`)}`"
        class="mt-12 h-44 w-64 md:mt-16 md:h-64 md:w-100 lg:h-83 lg:w-130"
      />
    </div>
  </div>
</template>
